import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-btn-one',
  templateUrl: './btn-one.component.html',
  styleUrls: ['./btn-one.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class BtnOneComponent implements OnInit {
  @Input() queryParams: any = {};
  @Input() link: string = "";
  @Input() text: string = "";
  @Input() textClass: string = " text-base";
  @Input() seoDesc: string = "";
  @Input() svg: string = "";
  @Input() svgClass: string = "";
  @Input() isDisabled: boolean = false;
  @Input() styleColor: string = "green-blue";//red-purple
  @Output() onClick: EventEmitter<boolean> = new EventEmitter();

  constructor(private sharedService: SharedService,) { }

  ngOnInit(): void { }

  onClickFire() {
    if (!this.isDisabled) this.onClick.emit();
  }

  isExternalMethod(link: string) {
    return this.sharedService.isExternalMethod(link);
  }

}
